export const options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3Mzc1N2YzMjViYmUwNTlkM2I2NzJmMWZkZTUwNmIwYSIsInN1YiI6IjY2MGNjNGZjNWFhZGM0MDE2MzY0MjQwZiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.tq1a3H5SmI75fCikJPylAmvByJSCbv-Ervz0hKUHTaY",
  },
};
